import { useTranslation } from 'react-i18next';

type useResponseTypeDescriptionReturn = {
  getResponseTypeDescription: (responseType: string | undefined) => string | undefined;
};

export const useResponseTypeDescription = (): useResponseTypeDescriptionReturn => {
  const { t } = useTranslation('consultation_response');

  const getResponseTypeDescription = (
    responseType: string | undefined
  ): string | undefined => {
    const responseDescriptions: Record<string, () => string | undefined> = {
      'No response': () =>
        t('response_type_description_no_response', 'The consultee has no response to make.'),
      Content: () =>
        t(
          'response_type_description_content',
          'On the basis of the information available, the consultee is content with the development as proposed or content subject to conditions.'
        ),
      Advice: () =>
        t(
          'response_type_description_advice',
          'The planning authority is provided with advice to enable the determination of the application. This could include that the proposal is contrary to policy in its present form.'
        ),
      'Standing advice': () =>
        t(
          'response_type_description_standing_advice',
          'The planning authority is referred to current standing advice by the consultee on the subject of the consultation.'
        ),
      'Consulted in error': () =>
        t(
          'response_type_description_consulted_in_error',
          'The consultee considers they were consulted in error and will not be providing a response.'
        ),
      'More information required': () =>
        t(
          'response_type_description_more_information_required',
          'More information is needed to make a determination on the application.'
        ),
      Supportive: () =>
        t(
          'response_type_description_supportive',
          'On the basis of the information available, the consultee is supportive with the development as proposed or supportive subject to conditions.'
        ),
      Unsupportive: () =>
        t(
          'response_type_description_unsupportive',
          'On the basis of the information available, the consultee is unsupportive with the development as proposed or unsupportive subject to conditions.'
        ),
      'For comment': () =>
        t(
          'response_type_description_for_comment',
          'The consultee would like to make a comment about the application.'
        ),
      'For information': () =>
        t(
          'response_type_description_for_information',
          'The consultee would like to provide information about the application.'
        ),
      'No comment': () =>
        t('response_type_description_no_comment', 'The consultee has no comment to make.'),
      'Consultation not required': () =>
        t(
          'response_type_description_not_required',
          'The consultee considers that a consultation is not required.'
        ),
      '': () => '',
    };
    return responseType ? responseDescriptions[responseType]?.() : '';
  };

  return {
    getResponseTypeDescription,
  };
};
